<script>
    import {url} from "@sveltech/routify";
    import {_} from 'svelte-i18n';
    import EventEditButton from "./EventEditButton.svelte";

    export let event;
</script>

<div class="row p-2">
    {#if event.game}
        <div class="col">
            <a href="{$url('/win', {  })}"
               class="btn btn-primary btn-md btn-block">{$_('component.event.buttons.win')}</a>
        </div>
    {/if}
    {#if event.ticket_url}
        <div class="col">
            <a href="{$url('/buy', { })}"
               class="btn btn-primary btn-md btn-block">
                {$_('component.event.buttons.buy')}
                {#if event.ticket_message}
                    *
                {/if}
            </a>
        </div>
    {/if}
</div>
